import React, { useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import working from '../components/img/working.jpeg';
import pet from '../components/img/pet.jpg';
import pet2 from '../components/img/pet2.jpg';
import video2 from '../components/videos/ginny-painting-2.mp4';
import '../css/home.css';
import LazyImage from '../components/LazyImage';

export default function AboutMe() {

  const videoRef = useRef(null);

  const handleVideoEnded = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };
  return (
    <Container>
      <h1 className="fs-3 mainTitle my-3">
        About Me
      </h1>
      <hr className="thicker-hr w-25" />
      <Row>
        <Col xs={12} md={6}>
          <p>
            Welcome to SeahorseArt! I’m Ginny Helsen, I am an Illustrator, Painter & Craftswoman.
            I live in the foothills of Snowdonia National Park and very close to the beach in gorgeous North Wales.​
            Surrounded by so much natural beauty I am inspired by Flora, Fauna, Scenery, Fantasy and Colour and
            endeavor to incorporate these images faithfully in my work.
          </p>
          <br />
          <p>
            My style tends to be Illustrative Realism when Drawing and Painting Animals, People, Nature, Sea, Land and Sky Scapes.
            I prefer to work with Pencils, Inks, Oil Pastels, Acrylic or Oil Paints, but love also working with Clay, Polymer Clay and Needle Felting.
          </p>
          <hr className="thicker-hr" />
          <h2 className="fs-5 mainTitle">
            What Can I Do For You?
          </h2>
          <p>
            I have formal training and qualifications in Fine Art, but, it is only through many years of practice and experience that I have been able to fully develop my style.
            <br />
            <br />
            I Illustrate, Decorate, Draw, Paint & Teach Art & Crafts.
            <br />
            <br />
            I can paint to order on virtually any surface from Walls to Canvas, Furniture to Ornaments, Paper to Wood, Slate to Stone.
          </p>
          <hr className="thicker-hr" />
          <h2 className="fs-5 mainTitle">
            Make a Style Statement
          </h2>
          <p>
            SeahorseArt has a small range of Stunning, Elegant and totally Unique Furniture pieces for sale
            to grace your home. Each piece has been carefully selected for its quality, practicality and style.
            It has then been renovated and hand painted with intricately detailed design.
            These are all beautiful, “one of a kind” conversation pieces, existing nowhere else in the world.
          </p>
        </Col>
        <Col xs={12} md={6} className="d-flex justify-content-center align-items-center">
          <LazyImage
                src={working}
                alt="Ginny Painting"
                className="image mb-3"
              />
        </Col>
      </Row>
      <hr className="thicker-hr" />

      <Row>
        <Col xs={12}>
          <h2 className="fs-5 mainTitle">
            ​BEAUTIFUL UNIQUE ARTWORK FOR YOUR HOME
          </h2>
          <p>
            Have you ever wished for something really special to place on your wall? I have a variety of unique original Paintings For Sale in my Online Gallery. Some are of local views, some surreal and some of animals. If you don’t see anything there, I can always paint or draw something bespoke which is just special to you. Paintings start from £95 making them the perfect special gift or self-indulgence!
            *Price reflects time and materials. All paintings are carefully and thoughtfully created over several hours, even days! The bigger they are and the more detail, the longer they take.
          </p>
        </Col>
      </Row>
        <video
        className='video mb-4'
        src={video2}
        width="100%"
        height="auto"
        autoPlay
        muted
        onEnded={handleVideoEnded}
        ref={videoRef}
      />
      <hr className="thicker-hr" />
      <Row>
        <Col xs={12} md={6}>
          <h2 className="fs-5 mainTitle">
            PET PORTRAITS & CUT OUT PAINTED ANIMALS
          </h2>
          <p>
            We all love our animals, and never forget them even after they’ve gone. I paint your favourite Pets onto Coasters, Hangers, Canvas and even plywood then cut them out! I specialize in “In Loving Memory” paintings for bereaved owners.
            <br />
            Prices from: Coaster £25, Slate Hanger £45, Canvas £95, Cut out £95
          </p>
        </Col>
        <Col xs={12} md={6} className="d-flex justify-content-center align-items-center">
          <LazyImage
                src={pet2}
                alt="Pet Portrait"
                className="image mb-3"
              />
        </Col>
      </Row>
      <hr className="thicker-hr" />

      <Row>
        <Col xs={12} md={6} className="d-flex justify-content-center align-items-center">
          <LazyImage
                src={pet}
                alt="Pet Portrait 2"
                className="image mb-3"
              />
        </Col>
        <Col xs={12} md={6}>
          <h2 className="fs-5 mainTitle">
            SLATE, STONE AND CERAMIC​
          </h2>
          <p>
            Fabulous Hand Painted Gifts form SeahorseArt. With a variety of Coasters, PotStands, Ornaments, Lazy Susan’s...you never need to be stuck for ideas again!
            I can paint virtually anything on anything and even personalize them for you. My prices won’t break you either!
          </p>
        </Col>
      </Row>

    </Container>
  )
};